import { AllUsers, Clickable, Col, Row, Text } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const FollowingFollowers = ({ user, isCurrentUser }) => {
  const [showAthletes, setShowAthletes] = useState(false);
  const isMobile = useSelector((state) => state.appState.isMobile);
  const { t } = useTranslation();
  const isAthlete = user.type === 'athlete';
  const isTeam = user.type === 'team';
  const isFan = user.type === 'fan';

  return (
    <Row start marg="10px 0 0 0" gap={isMobile ? '12px' : '24px'}>
      {user.type === 'team'
        ? !isMobile
        : true && (
            <Col noFlex row centerAll gap="6px">
              <Text b2 bold col={'#fff'}>
                {user?.followersCount}
              </Text>

              <Text c1 med col={'#fff'}>
                {t('common.followers')}
              </Text>
            </Col>
          )}

      <Col noFlex row centerAll gap="6px">
        <Text b2 bold col={'#fff'}>
          {isTeam ? user?.followersCount : user?.profileViewsCount || 0}{' '}
          {/* display views for athlete */}
        </Text>

        <Text c1 med col={'#fff'}>
          {isTeam ? t('common.followers') : t('dashboard.views')}
        </Text>
      </Col>

      {/* TEAM */}
      {isTeam && (
        <Col noFlex row centerAll gap="6px">
          <Text b2 bold col={'#fff'}>
            {user?.profileViewsCount}
          </Text>

          <Text c1 med col={'#fff'}>
            {t('dashboard.views')}
          </Text>
        </Col>
      )}

      {/* {isCurrentUser && (
      <Col noFlex row centerAll gap="6px">
          <Text b2 bold col={'#fff'}>{user.referalCount || 0}</Text>

          <Text c1 med col={'#fff'}>{t('common.referals')}</Text>
        </Col>
      )} */}

      {isTeam && (
        <Clickable noFlex onClick={() => setShowAthletes(true)}>
          <Col noFlex row centerAll gap="6px">
            <Text b2 bold col={'#fff'}>
              {user.athletes?.length || 0}
            </Text>

            <Text c1 med col={'#fff'}>
              {t('common.athletes')}
            </Text>
          </Col>
        </Clickable>
      )}

      {/* FAN sent shoutouts */}
      {isFan && (
        <Col noFlex row centerAll gap="6px">
          <Text b2 bold col={'#fff'}>
            {user.sentShoutouts?.length || 0}
          </Text>

          <Text c1 med col={'#fff'}>
            {t('dashboard.shoutouts')}
          </Text>
        </Col>
      )}

      {isTeam && (
        <AllUsers visible={showAthletes} closeModal={() => setShowAthletes(false)} team={user} />
      )}
    </Row>
  );
};

export default FollowingFollowers;
